import type { ButtonHTMLAttributes, MouseEvent, ReactNode } from "react";
import styles from "./MenuSheetItem.module.css";
import { cx } from "../cx";
import { IconChevronRightLine } from "../icons/Icon";
import { Switch } from "../components/Switch";

export type MenuSheetItemProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> & {
  icon?: ReactNode;
  label: ReactNode;
  detail?: ReactNode;
  tone?: "neutral" | "critical";
  suffix?: "none" | "chevron" | { switch: boolean; onSwitch: (v: boolean) => void };
};

/** SEED MenuSheetItem (Figma 97:3828). critical = 나가기·신고. 스위치 suffix는 1차 메뉴(숨기기 토글)용. */
export function MenuSheetItem({ icon, label, detail, tone = "neutral", suffix = "none", className, onClick, ...rest }: MenuSheetItemProps) {
  const isSwitch = typeof suffix === "object";
  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    if (isSwitch) suffix.onSwitch(!suffix.switch);
    onClick?.(e);
  };
  // 스위치 행은 <button> 중첩을 피하려고 div[role=switch]로 렌더링하고, 내부 Switch는 표시 전용이다.
  const Root = (isSwitch ? "div" : "button") as "button";
  const a11y = isSwitch ? { role: "switch", "aria-checked": suffix.switch, tabIndex: 0 } : { type: "button" as const };
  return (
    <Root {...a11y} className={cx(styles.root, styles[tone], className)} onClick={handleClick} {...rest}>
      {icon && <span className={styles.icon}>{icon}</span>}
      <span className={styles.label}>{label}</span>
      {detail && <span className={styles.detail}>{detail}</span>}
      {suffix === "chevron" && <IconChevronRightLine size={16} className={styles.chevron} />}
      {isSwitch && <Switch checked={suffix.switch} onCheckedChange={() => {}} tabIndex={-1} aria-hidden style={{ pointerEvents: "none" }} />}
    </Root>
  );
}
